import { List, OrderedList, Span } from '@telus-uds/components-web'
import { useMemo, useContext } from 'react'
import { ListSize } from '../RichText/TypographyVariantTypes'
import type { TypeListItemWithoutUnresolvableLinksResponse } from '@/contentful-types'
import { getIcon } from '@/siteBuilder/utils/getIcon'
import { LegalTextRenderer } from 'src/siteBuilder/utils/text/TextRenderer'
import { withLegalText } from '../../../utils/text/withLegalText'
import { SiteBuilderContext } from '../../../renderer/context/SiteBuilderContext'

type ListItemProps = {
  ListComponent: typeof List | typeof OrderedList
  item: TypeListItemWithoutUnresolvableLinksResponse
  iconSize: number
  textSize: ListSize
}

const ListItem = ({ ListComponent, item, textSize, iconSize, ...rest }: ListItemProps) => {
  const { brand } = useContext(SiteBuilderContext)

  const IconComponent = useMemo(
    () => (item.fields?.iconName ? getIcon(item.fields?.iconName, brand) : undefined),
    [brand, item.fields?.iconName]
  )

  const iconProps = !!IconComponent
    ? {
        icon: IconComponent,
        iconColor: item.fields?.iconColor2,
        iconSize: iconSize,
      }
    : null

  const iconMarginTop = textSize === 'large' ? 4 : undefined

  return (
    <ListComponent.Item
      {...rest}
      title={withLegalText(item.fields?.heading)}
      {...iconProps}
      tokens={{ iconMarginTop: iconMarginTop }}
    >
      <Span variant={{ size: textSize }}>
        <LegalTextRenderer>{item.fields?.text}</LegalTextRenderer>
      </Span>
    </ListComponent.Item>
  )
}

export default ListItem
